// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"a361179b","235":"966a35e3","297":"b2950cce","300":"0552fc19","305":"63714006","464":"e91a62e7","582":"6f6da745","587":"1b3f1e04","605":"a1a41d55","719":"172c646e","779":"363db377","783":"a67b7eaa","894":"6f799980","920":"9e66db66","986":"d72b4372","995":"468db2f8"}[chunkId] + ".chunk.js";
};